export * from "./TabelaMarketShare";
